
import React from "react";
import { Box } from "@mui/material";

interface MapLocationProps {
  onClick?: () => void;
}

export const MapLocation: React.FC<MapLocationProps> = ({ onClick }) => {
  return (
    <Box 
      sx={{
        position: 'absolute',
        zIndex: 0,
        display: 'flex',
        width: '40px',
        flexDirection: 'column',
        height: '40px',
        left: '147px',
        bottom: '189px',
        cursor: 'pointer',
        transition: 'transform 0.2s',
        '&:hover': {
          transform: 'scale(1.1)',
        },
        '&:active': {
          transform: 'scale(0.95)',
        },
      }}
      onClick={onClick}
    >
      <Box 
        sx={{
          backgroundColor: 'rgba(224,0,131,0.1)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '40px',
          padding: '4px',
          borderRadius: '50%',
        }}
      >
        <Box 
          sx={{
            backgroundColor: 'rgba(224,0,131,0.15)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '22px',
            padding: '4px',
            borderRadius: '50%',
          }}
        >
          <Box 
            sx={{
              backgroundColor: '#E00083',
              display: 'flex',
              width: '8px',
              flexShrink: 0,
              height: '8px',
              borderRadius: '50%',
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
